import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/arrow-left-dark.svg";
import { Link } from "react-router-dom";
import { useStateContext } from "../../../../contexts/ThemeContext";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  gettingLinkList,
  resetLinkList,
} from "../../../../redux/slices/gettingLinksList/gettingLinkListSlice";

import { gettingSettingUpdataData } from "../../../../redux/slices/appearance/appearanceSlice";

import AddBlockTabArea from "./addBlocks/AddBlockTabArea";
import ViewBlocksTabArea from "./viewBlockCards/ViewBlocksTabArea";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";
import { Helmet } from "react-helmet";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { setShowForm, setShowLocationData, setEditingLocation } from '../../../../redux/slices/location/locationSlice';


// This is the main entry page after login and It divides in two tabs with Add Block and View Block

const Index = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  const { isAddBlockTab, setisAddBlockTab } = useStateContext();

  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();

  useEffect(() => {
    setActiveMainPageNav(true);
    fetchingLinkList();
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLinkState = useSelector((state) => state?.gettingBioLinksState);
  const fetchingLinkList = async () => {
    // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
    const linkId =
      localStorage.getItem("linkId") ||
      getLinkState?.getBioLink?.response?.[0]?._id;
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.userid;
    const usertoken = user?.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    const data = {
      linkData: linkId,
      userData: userId,
    };
    if (linkId && userId) {
      await dispatch(gettingLinkList(linkListData));
      dispatch(gettingSettingUpdataData(data));
      dispatch(resetLinkList());
    }
  };

  const mylinkstate = useSelector((state) => state?.linkList || []);
  const myData = mylinkstate?.getLinkList?.response;

  const [mylinkstateSorted, setLinkList] = useState([]);

  useEffect(() => {
    setLinkList(myData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mylinkstate]);

  useEffect(() => {
    dispatch(setShowForm(false));
    dispatch(setShowLocationData(false));
    dispatch(setEditingLocation(null));
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Components | Bil.Bio</title>
        <meta property="og:title" content="Components | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>

      <>
        <div className="flex md:hidden mt-10 mb-[38px] relative items-center">
          <div className="absolute start-6 inset-y-0 flex items-center justify-center">
            <Link to={"/mDashboard"}>
              {darkMode ? (
                <LeftArrowDark
                  className={`h-[20px] w-[20px] ${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`h-[20px] w-[20px] ${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </Link>
          </div>
          <h6 className="w-full text-center text-body_copy1_b dark:text-color_v1_dark">
            {translate("components")}
          </h6>
        </div>
        <div className="px-6 md:px-0">
          <div className="border-b flex gap-[30px]">
            <div
              onClick={() => setisAddBlockTab(true)}
              className={
                isAddBlockTab
                  ? "text-small2_b sm:text-small1_bold  pb-2.5 text-dark_bg_v1 border-b-2 border-dark_bg_v1 cursor-pointer dark:text-color_v1_dark"
                  : "text-small2 sm:text-small1 pb-2.5 text-dark_bg_v5 cursor-pointer"
              }
            >
              {translate("addBlock.addBlocks")}
            </div>
            <div
              onClick={() => setisAddBlockTab(false)}
              className={
                !isAddBlockTab
                  ? "text-small2_b sm:text-small1_bold pb-2.5 text-dark_bg_v1 border-b-2 border-dark_bg_v1 cursor-pointer dark:text-color_v1_dark"
                  : "text-small2 sm:text-small1 pb-2.5 text-dark_bg_v5 cursor-pointer"
              }
            >
              {translate("addBlock.viewBlock")}
            </div>
          </div>
        </div>
        {isAddBlockTab && <AddBlockTabArea />}
        {!isAddBlockTab && (
          <ViewBlocksTabArea mylinkstateSorted={mylinkstateSorted} />
        )}
      </>
    </>
  );
};

export default Index;
